import { render, staticRenderFns } from "./SayfaListesi.vue?vue&type=template&id=c4ed8690&scoped=true&"
import script from "./SayfaListesi.vue?vue&type=script&lang=js&"
export * from "./SayfaListesi.vue?vue&type=script&lang=js&"
import style0 from "./SayfaListesi.vue?vue&type=style&index=0&id=c4ed8690&lang=scss&scoped=true&"
import style1 from "./SayfaListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed8690",
  null
  
)

export default component.exports